
<template>
    <div class="share-with-friend">
        <h4>
            {{ trans('title') }}
        </h4>

        <form 
            @submit.prevent="sendToFriend" 
            @keydown="form.errors.clear($event.target.name)"
        >
            <my-input
                v-model="form.type"
                name="type"
                type="hidden"
            />

            <my-input
                v-model="form.friend_name"
                name="friend_name"
                :label="trans('labels.friend_name')"
            />

            <error-span :error="form.errors.get('friend_name')"></error-span>

            <my-input
                v-model="form.friend_email"
                name="friend_email"
                type="email"
                :label="trans('labels.friend_email')"
            />
            
            <error-span :error="form.errors.get('friend_email')"></error-span>
            

            <my-input
                v-model="form.your_name"
                name="your_name"
                :label="trans('labels.your_name')"
            />

            <error-span :error="form.errors.get('your_name')"></error-span>

            <my-input
                v-model="form.your_email"
                name="your_email"
                type="email"
                :label="trans('labels.your_email')"
            />
            
            <error-span :error="form.errors.get('your_email')"></error-span>

            <my-textarea
                v-model="form.message"
                name="message"
                :label="trans('labels.message')"
            />

            <error-span :error="form.errors.get('message')"></error-span>

            <div class="privacy-policy" v-html="trans('agreements.privacy.label', { link: trans('agreements.privacy.link') })"></div>

            <button class="btn btn-network">
                {{ trans('labels.send') }}
            </button>
        </form>
    </div>
</template>

<script>
import { Form } from '../../classes/Form'

export default {
    props: {
        estateId: {
            required: true
        },
        type:{
            type:String,
            default:'estate',
        }
    },

    data() {
        return {
            form: new Form({
                friend_name: '',
                friend_email: '',

                your_name: '',
                your_email: '',
           
                estate: this.estateId,

                // marketing: false,
                message: '',
                type: this.type,
            }),

            rules: {
                friend_email: ['required', 'email'],
                friend_name: ['required'],
                your_email: ['required', 'email'],
                your_name: ['required'],

            },
        }
    },

    computed:{
        lang(){
            return this.$root.lang.share_form
        }
    },

    methods: {
        sendToFriend() {
            if(! this.form.validate(this.rules)) {
                return false
            }
            
            isLoading()

            this.form.post('/api/' + this.type + 's/send-to-friend')
                .then((data) => {
                    stopLoading()

                    flash(this.lang.flash.success)
                    this.$parent.close()
                })
                .catch(response => {
                    stopLoading()

                    flash(this.lang.flash.error, 'warning')
                })
        },
    },
}
</script>

<style>

</style>